import React from 'react';
import { Field, FormSpy } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';

interface Props {
    fieldToBeChanged: string;
    fieldToBeListened: string;
}

/*
    This component is used when you need to set value of one Field based on another Field's value.
    It subscribes to the fieldToBeListened's onChange, so it will get its new value
    and trigger the fieldToBeChanged's onChange passing this value.
*/
const ChangeFieldValueBasedOnAnotherFieldValue = ({
    fieldToBeChanged,
    fieldToBeListened,
}: Props): React.ReactElement => (
    <Field name={fieldToBeChanged} subscription={{}}>
        {({ input: { onChange } }): React.ReactElement => (
            <FormSpy subscription={{}}>
                {({ form }): React.ReactElement => (
                    // @ts-ignore
                    <OnChange name={fieldToBeListened}>
                        {(value): void => {
                            onChange(value);
                        }}
                    </OnChange>
                )}
            </FormSpy>
        )}
    </Field>
);

export default ChangeFieldValueBasedOnAnotherFieldValue;
